import React, { useState } from 'react';
import { apiClient as api } from '@/lib/api';
import FlightTracker from '@/features/track/components/FlightTracker';

const GenerateToken = () => {
  const [quoteId, setQuoteId] = useState('');
  const [orgId, setOrgId] = useState('');
  const [amount, setAmount] = useState('0');
  const [generatedUrl, setGeneratedUrl] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleGenerate = async () => {
    if (!quoteId.trim()) {
      setError('Quote ID is required');
      return;
    }

    setLoading(true);
    setError('');
    setGeneratedUrl('');

    try {
      const requestToken = await api.createCheckoutToken({
        quote_id: quoteId.trim(),
        amount: parseFloat(amount) || 0,
        currency: 'USD',
        payment_method: 'CREDIT_CARD',
        description: 'Charter flight quote payment',
        metadata: {
          customer_name: 'Test User',
          customer_email: 'test@example.com',
        },
      });

      const url = `${window.location.origin}/quotepreview?quote=${quoteId.trim()}&token=${requestToken?.token}&org=${orgId.trim()}`;
      setGeneratedUrl(url);
    } catch (err) {
      setError(err.message || 'Failed to generate token');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-md p-6 w-full max-w-md space-y-4">
        <h1 className="text-xl font-bold text-gray-900">Generate Quote Token</h1>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Quote ID *</label>
          <input
            type="text"
            value={quoteId}
            onChange={(e) => setQuoteId(e.target.value)}
            placeholder="e.g. QT-12345"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Organization ID *</label>
          <input
            type="text"
            value={orgId}
            onChange={(e) => setOrgId(e.target.value)}
            placeholder="e.g. ORG-12345"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Amount</label>
          <input
            type="number"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            placeholder="0"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        <button
          onClick={handleGenerate}
          disabled={loading}
          className="w-full py-2 bg-blue-600 text-white rounded-lg text-sm font-medium hover:bg-blue-700 disabled:opacity-50"
        >
          {loading ? 'Generating...' : 'Generate Token URL'}
        </button>

        {error && (
          <p className="text-sm text-red-600">{error}</p>
        )}

        {generatedUrl && (
          <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-700">Generated URL:</label>
            <div className="p-3 bg-gray-100 rounded-lg break-all text-sm text-gray-800 select-all">
              {generatedUrl}
            </div>
            <button
              onClick={() => navigator.clipboard.writeText(generatedUrl)}
              className="w-full py-2 border border-gray-300 text-gray-700 rounded-lg text-sm font-medium hover:bg-gray-50"
            >
              Copy to Clipboard
            </button>
            <a
              href={generatedUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="block w-full py-2 text-center border border-blue-300 text-blue-700 rounded-lg text-sm font-medium hover:bg-blue-50"
            >
              Open in New Tab
            </a>
          </div>
        )}
      </div>

      <div className="w-full mt-6" style={{ height: '500px' }}>

        <FlightTracker />
      </div>
    </div>
  );
};

export default GenerateToken;